module.exports = __webpack_public_path__ + "static/img/rank_6.994f918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_6.png
// module id = 9539
// module chunks = 1